var React = require('react');

function IconExplore (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M16,0A16,16,0,1,0,32,16,16,16,0,0,0,16,0Zm0,28.8A12.8,12.8,0,1,1,28.8,16,12.8,12.8,0,0,1,16,28.8Z","key":0}),React.createElement("path",{"d":"M8.32,23.68l10.62-4.74L23.68,8.32,13.06,13.06Zm12.2-12.2-2.1,4.69-2.6-2.6Z","key":1})]);
}

IconExplore.defaultProps = {"id":"explore","viewBox":"0 0 32 32"};

module.exports = IconExplore;

IconExplore.default = IconExplore;
